/* DouceFit: scoped gallery, pack selection and the store's single cart entry point. */
(function () {
  'use strict';
  var root = document.querySelector('[data-df-page]');
  if (!root || root.dataset.dfReady) return;
  root.dataset.dfReady = 'true';
  var $ = function (s, context) { return (context || root).querySelector(s); };
  var $$ = function (s, context) { return Array.from((context || root).querySelectorAll(s)); };
  var variants = JSON.parse($('[data-df-variants]').textContent);
  var money = new Intl.NumberFormat(root.dataset.locale || 'fr-FR', { style: 'currency', currency: root.dataset.currency || 'EUR' });
  var fmt = function (n) { return money.format(n / 100); };
  var cards = $$('[data-df-offer]');
  var form = $('[data-df-form]');
  var mainATC = $('[data-df-atc]');
  var sticky = $('[data-df-sticky]');
  var stickyATC = $('[data-df-sticky-atc]');
  var selectedOffer = $('[name="df-offer"]:checked').value;
  var initialColor = $('[data-df-color]').value;
  var otherColors = Array.from(new Set(variants.map(function (v) { return v.option1; }))).filter(function (color) { return color !== initialColor; });
  var pieces = [0, 1, 2].map(function (i) { return { color: i === 0 ? initialColor : otherColors[i - 1] || initialColor, size: $('[data-df-size]').value, customSize: false, customColor: false }; });
  var soloOffer = cards[0].dataset.dfOffer;
  var selectedVariant;
  var selectedCount = 1;
  var findVariant = function (offer, piece) { return variants.find(function (v) { return v.option1 === piece.color && v.option2 === piece.size && v.option3 === offer; }); };
  var currencyPrice = function (v) { return v ? Number(v.price) : 0; };
  var colorImageIndex = { Beige: 1, Noir: 4, Chocolat: 5 };
  var gallery = $('[data-df-gallery]');
  var slides = $$('[data-df-slide]');
  var thumbs = $$('[data-df-thumb]');
  var currentSlide = 0;
  var promoImages = [slides[6] && slides[6].querySelector('img'), thumbs[6] && thumbs[6].querySelector('img'), $('.df-section--rose .df-split > img')].filter(Boolean);
  var promoOriginals = promoImages.map(function (img) { return { src: img.getAttribute('src'), srcset: img.getAttribute('srcset'), alt: img.alt }; });

  function showSlide(index, revealThumb) {
    if (!slides.length) return;
    currentSlide = (index + slides.length) % slides.length;
    slides.forEach(function (slide, i) { var active = i === currentSlide; slide.classList.toggle('is-active', active); slide.setAttribute('aria-hidden', String(!active)); });
    thumbs.forEach(function (thumb, i) { thumb.setAttribute('aria-current', String(i === currentSlide)); });
    $('[data-df-count]').textContent = (currentSlide + 1) + ' / ' + slides.length;
    if (revealThumb && thumbs[currentSlide]) {
      var track = $('[data-df-thumbs]');
      var thumb = thumbs[currentSlide];
      track.scrollTo({ left: Math.max(0, thumb.offsetLeft - track.clientWidth / 2 + thumb.clientWidth / 2), behavior: 'auto' });
    }
    var nextImage = slides[(currentSlide + 1) % slides.length].querySelector('img');
    if (nextImage) { var preload = new Image(); preload.src = nextImage.currentSrc || nextImage.src; }
  }
  thumbs.forEach(function (t) { t.addEventListener('click', function () { showSlide(Number(t.dataset.dfThumb), true); }); });
  $('[data-df-prev]').addEventListener('click', function () { showSlide(currentSlide - 1, true); });
  $('[data-df-next]').addEventListener('click', function () { showSlide(currentSlide + 1, true); });
  gallery.addEventListener('keydown', function (e) { if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') { e.preventDefault(); showSlide(currentSlide + (e.key === 'ArrowRight' ? 1 : -1), true); } });
  var touchX = 0, touchY = 0;
  $('[data-df-viewport]').addEventListener('touchstart', function (e) { touchX = e.changedTouches[0].clientX; touchY = e.changedTouches[0].clientY; }, { passive: true });
  $('[data-df-viewport]').addEventListener('touchend', function (e) { var dx = e.changedTouches[0].clientX - touchX; var dy = e.changedTouches[0].clientY - touchY; if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) showSlide(currentSlide + (dx < 0 ? 1 : -1), true); }, { passive: true });
  showSlide(0, false);

  function sync() {
    var currentCard = cards.find(function (card) { return card.dataset.dfOffer === selectedOffer; });
    selectedCount = Number(currentCard.dataset.count);
    selectedVariant = findVariant(selectedOffer, pieces[0]);
    cards.forEach(function (card) {
      var active = card === currentCard;
      var count = Number(card.dataset.count);
      var variant = findVariant(card.dataset.dfOffer, pieces[0]);
      card.classList.toggle('is-selected', active);
      $('[name="df-offer"]', card).checked = active;
      $('[data-df-pieces]', card).hidden = !active;
      $('[data-df-offer-price]', card).textContent = variant ? fmt(variant.price) : 'Indisponible';
      $('[data-df-offer-unit]', card).textContent = variant ? fmt(variant.price / count) + ' / pièce' : '';
      $$('[data-df-piece]', card).forEach(function (row, i) {
        $('[data-df-color]', row).value = pieces[i].color;
        $('[data-df-size]', row).value = pieces[i].size;
        var img = $('.df-piece-photo', row);
        var slide = slides[colorImageIndex[pieces[i].color]];
        if (slide && img) {
          var photo = slide.querySelector('img');
          var source = new URL(photo.src, location.href);
          source.searchParams.set('width', '100');
          img.removeAttribute('srcset'); img.src = source.href; img.alt = 'DouceFit ' + pieces[i].color.toLowerCase();
        }
      });
    });
    var price = currencyPrice(selectedVariant);
    var singleTotal = pieces.slice(0, selectedCount).reduce(function (sum, piece) { return sum + currencyPrice(findVariant(soloOffer, piece)); }, 0);
    var saved = Math.max(0, singleTotal - price);
    $('[data-df-price]').textContent = selectedVariant ? fmt(price) : 'Indisponible';
    $('[data-df-atc-price]').textContent = selectedVariant ? fmt(price) : '';
    $('[data-df-sticky-price]').textContent = selectedVariant ? fmt(price) : '';
    $('[data-df-compare]').hidden = !(selectedCount > 1 && saved > 0);
    $('[data-df-compare]').textContent = fmt(singleTotal);
    $('[data-df-saving]').hidden = !(saved > 0);
    $('[data-df-saving]').textContent = 'Économisez ' + fmt(saved) + (singleTotal > 0 ? ' · −' + Math.round(saved / singleTotal * 100) + ' %' : '');
    $('[data-df-price-caption]').textContent = saved > 0 ? 'Par rapport aux ' + selectedCount + ' pièces achetées séparément.' : 'Livraison suivie offerte.';
    $('[data-df-variant-id]').value = selectedVariant ? selectedVariant.id : '';
    var trio = findVariant(cards[2].dataset.dfOffer, pieces[0]);
    var soloPrice = currencyPrice(findVariant(soloOffer, pieces[0]));
    var paidTwoTotal = pieces.slice(0, 2).reduce(function (sum, piece) { return sum + currencyPrice(findVariant(soloOffer, piece)); }, 0);
    var giftEligible = Boolean(trio && soloPrice > 0 && Number(trio.price) <= paidTwoTotal);
    var trioBestUnit = Boolean(trio && cards.slice(0, 2).every(function (card) { var v = findVariant(card.dataset.dfOffer, pieces[0]); return v && Number(trio.price) / 3 <= Number(v.price) / Number(card.dataset.count); }));
    $('[data-df-trio-tag]').textContent = trioBestUnit ? 'Le trio · Votre meilleur prix par pièce' : 'Le trio · Trois pièces à composer';
    $('[data-df-offer-title]', cards[2]).textContent = giftEligible ? '2 achetés + 1 offert' : 'Le trio · 3 soutiens-gorge';
    $('[data-df-gift]').hidden = !(selectedCount === 3 && giftEligible);
    $('[data-df-gift-value]').textContent = fmt(currencyPrice(findVariant(soloOffer, pieces[2])));
    $('[data-df-final-offer]').textContent = giftEligible ? '2 achetés + 1 offert. Votre troisième pièce est comprise dans le trio.' : 'Trois pièces à composer dans vos couleurs et vos tailles.';
    promoImages.forEach(function (img, i) {
      var source = giftEligible ? promoOriginals[i] : { src: slides[0].querySelector('img').getAttribute('src'), srcset: slides[0].querySelector('img').getAttribute('srcset'), alt: 'DouceFit : présentation du modèle' };
      if (img.getAttribute('src') !== source.src) img.setAttribute('src', source.src);
      if (source.srcset) img.setAttribute('srcset', source.srcset); else img.removeAttribute('srcset');
      img.alt = source.alt;
    });
    var allAvailable = pieces.slice(0, selectedCount).every(function (piece) { var v = findVariant(soloOffer, piece); return v && v.available; });
    var disabled = form.dataset.busy === 'true' || !selectedVariant || !selectedVariant.available || !allAvailable;
    mainATC.disabled = disabled; stickyATC.disabled = disabled;
    $$('[data-df-color], [data-df-size], [name="df-offer"]', form).forEach(function (input) { input.disabled = form.dataset.busy === 'true'; });
    if (selectedVariant) { var url = new URL(location.href); url.searchParams.set('variant', selectedVariant.id); history.replaceState({}, '', url.href); }
  }
  cards.forEach(function (card) {
    $('[name="df-offer"]', card).addEventListener('change', function () { selectedOffer = card.dataset.dfOffer; sync(); });
    $$('[data-df-piece]', card).forEach(function (row, index) {
      $('[data-df-color]', row).addEventListener('change', function (e) { pieces[index].color = e.target.value; pieces[index].customColor = true; sync(); if (index === 0) showSlide(colorImageIndex[pieces[index].color], true); });
      $('[data-df-size]', row).addEventListener('change', function (e) {
        pieces[index].size = e.target.value;
        if (index === 0) pieces.slice(1).forEach(function (piece) { if (!piece.customSize) piece.size = e.target.value; });
        else pieces[index].customSize = true;
        sync();
      });
    });
  });
  $$('[data-df-select-trio]').forEach(function (link) { link.addEventListener('click', function () { selectedOffer = cards[2].dataset.dfOffer; sync(); }); });
  $$('[data-df-color-choose]').forEach(function (button) {
    button.addEventListener('click', function () {
      if (form.dataset.busy === 'true') return;
      var color = button.dataset.dfColorChoose;
      if (!variants.some(function (v) { return v.option1 === color; })) return;
      pieces[0].color = color; pieces[0].customColor = true;
      sync(); showSlide(colorImageIndex[color], true);
      form.scrollIntoView({ block: 'start', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      $('[data-df-color]', cards.find(function (card) { return card.dataset.dfOffer === selectedOffer; })).focus({ preventScroll: true });
    });
  });
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (form.dataset.busy === 'true' || mainATC.disabled || !selectedVariant) return;
    var properties = { Offre: selectedOffer, 'Pièces dans le lot': String(selectedCount) };
    pieces.slice(0, selectedCount).forEach(function (piece, i) { properties['DouceFit ' + (i + 1)] = piece.color + ' · ' + piece.size; });
    form.dataset.busy = 'true'; $('[data-df-error]').hidden = true; sync();
    document.dispatchEvent(new CustomEvent('cart:add', {
      detail: {
        source: 'doucefit-product', items: [{ id: selectedVariant.id, quantity: 1, properties: properties }],
        onSuccess: function () { form.dataset.busy = 'false'; sync(); updateSticky(); },
        onError: function () { form.dataset.busy = 'false'; $('[data-df-error]').textContent = 'L’ajout n’a pas abouti. Réessayez dans un instant.'; $('[data-df-error]').hidden = false; sync(); }
      }
    }));
  });
  stickyATC.addEventListener('click', function () {
    if (sticky.dataset.dfStickyMode === 'choose') {
      form.scrollIntoView({ block: 'start', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      $('[name="df-offer"]:checked').focus({ preventScroll: true });
      return;
    }
    form.requestSubmit();
  });
  function updateSticky() {
    var atcBounds = mainATC.getBoundingClientRect();
    var afterATC = atcBounds.bottom < 0;
    var beforeATC = gallery.getBoundingClientRect().bottom < 60 && atcBounds.top >= window.innerHeight;
    var writingReview = document.activeElement && document.activeElement.closest('.df-review-form');
    var visible = window.innerWidth <= 749 && (afterATC || beforeATC) && !document.body.classList.contains('gscd-cart-open') && !root.querySelector('dialog[open]') && !writingReview;
    sticky.dataset.dfStickyMode = afterATC ? 'add' : 'choose';
    stickyATC.textContent = afterATC ? 'Ajouter au panier' : 'Choisir mon offre';
    sticky.classList.toggle('is-visible', visible); sticky.setAttribute('aria-hidden', String(!visible));
    stickyATC.tabIndex = visible ? 0 : -1;
  }
  new IntersectionObserver(updateSticky).observe(mainATC);
  new MutationObserver(updateSticky).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  window.addEventListener('resize', updateSticky, { passive: true });
  window.addEventListener('scroll', updateSticky, { passive: true });
  root.addEventListener('focusin', updateSticky);
  root.addEventListener('focusout', function () { requestAnimationFrame(updateSticky); });
  sync(); updateSticky();

  var dialog = $('[data-df-size-dialog]');
  var opener;
  $$('[data-df-size-open]').forEach(function (button) { button.addEventListener('click', function () { opener = button; dialog.showModal(); updateSticky(); }); });
  $('[data-df-size-close]').addEventListener('click', function () { dialog.close(); });
  dialog.addEventListener('click', function (e) { if (e.target === dialog) { var b = dialog.getBoundingClientRect(); if (e.clientX < b.left || e.clientX > b.right || e.clientY < b.top || e.clientY > b.bottom) dialog.close(); } });
  dialog.addEventListener('close', function () { if (opener) opener.focus({ preventScroll: true }); updateSticky(); });
  var sizeMap = { S: ['80E','85B','85C','85D','90A'], M: ['90B','90C','90D','90E','95A','95B'], L: ['95C','95D','100A','100B'], XL: ['95E','100C','100D','105B'], '2XL': ['100E','105C','105D','110B'], '3XL': ['105E','110C','110D','115B','115C'] };
  var recommendedSize;
  function recommend() {
    var band = $('[data-df-band]').value, cup = $('[data-df-cup]').value;
    recommendedSize = Object.keys(sizeMap).find(function (size) { return sizeMap[size].includes(band + cup); });
    $('[data-df-size-apply]').hidden = !recommendedSize;
    $('[data-df-size-result]').textContent = !band || !cup ? 'Sélectionnez votre tour de dos et votre bonnet.' : recommendedSize ? 'Votre correspondance : DouceFit ' + recommendedSize + '.' : 'Cette taille n’a pas de correspondance dans notre guide. Contactez notre équipe pour vous aider à choisir.';
    if (recommendedSize) $('[data-df-size-apply]').textContent = 'Choisir la taille ' + recommendedSize;
  }
  $('[data-df-band]').addEventListener('change', recommend); $('[data-df-cup]').addEventListener('change', recommend);
  $('[data-df-size-apply]').addEventListener('click', function () { if (!recommendedSize) return; pieces.forEach(function (piece, i) { if (i === 0 || !piece.customSize) piece.size = recommendedSize; }); sync(); dialog.close(); });

  var track = $('[data-df-photo-track]'), photoCards = $$('.df-photo-card', track);
  function photoPosition() { var step = photoCards[0].getBoundingClientRect().width + 18; return Math.max(0, Math.min(photoCards.length - 1, Math.round(track.scrollLeft / (step || 1)))); }
  function updatePhotos() { var at = photoPosition(); $('[data-df-photo-count]').textContent = (at + 1) + ' / ' + photoCards.length; $('[data-df-photo-prev]').disabled = track.scrollLeft <= 1; $('[data-df-photo-next]').disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2; }
  function shiftPhotos(delta) { track.scrollBy({ left: delta * (photoCards[0].getBoundingClientRect().width + 18), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }); }
  $('[data-df-photo-prev]').addEventListener('click', function () { shiftPhotos(-1); }); $('[data-df-photo-next]').addEventListener('click', function () { shiftPhotos(1); });
  track.addEventListener('scroll', updatePhotos, { passive: true }); window.addEventListener('resize', updatePhotos, { passive: true });
  track.addEventListener('keydown', function (e) { if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') { e.preventDefault(); shiftPhotos(e.key === 'ArrowRight' ? 1 : -1); } });
  updatePhotos();

  var reviewDetails = $('[data-df-review-details]');
  var reviewTrack = $('[data-df-review-track]');
  if (reviewTrack) {
    var reviewCards = $$('[data-df-review-track] .df-review-card');
    var reviewCount = $('[data-df-review-count]');
    var reviewIndex = function () {
      if (!reviewCards.length) return 0;
      var left = reviewTrack.scrollLeft;
      var closest = 0;
      var distance = Infinity;
      reviewCards.forEach(function (card, index) {
        var delta = Math.abs(card.offsetLeft - reviewTrack.offsetLeft - left);
        if (delta < distance) { distance = delta; closest = index; }
      });
      return closest;
    };
    var updateReviewCount = function () {
      if (reviewCount) reviewCount.textContent = String(reviewIndex() + 1) + ' / ' + String(reviewCards.length);
    };
    var moveReview = function (direction) {
      var next = Math.max(0, Math.min(reviewCards.length - 1, reviewIndex() + direction));
      if (reviewCards[next]) reviewTrack.scrollTo({
        left: reviewCards[next].offsetLeft - reviewCards[0].offsetLeft,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    };
    var reviewPrev = $('[data-df-review-prev]');
    var reviewNext = $('[data-df-review-next]');
    if (reviewPrev) reviewPrev.addEventListener('click', function () { moveReview(-1); });
    if (reviewNext) reviewNext.addEventListener('click', function () { moveReview(1); });
    reviewTrack.addEventListener('scroll', function () { window.requestAnimationFrame(updateReviewCount); }, { passive: true });
    window.addEventListener('resize', updateReviewCount, { passive: true });
    updateReviewCount();
  }
  $$('[data-df-review-open]').forEach(function (button) {
    button.addEventListener('click', function () {
      if (!reviewDetails) return;
      reviewDetails.open = true;
      reviewDetails.scrollIntoView({ block: 'start', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      var firstField = $('#df-review-name'); if (firstField) firstField.focus({ preventScroll: true });
    });
  });
  if (reviewDetails && ($('[data-df-review-success]') || $('[data-df-review-errors]'))) reviewDetails.open = true;
})();
